import React, { useCallback, useRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  getColor,
  Icons,
  InputField,
  Modal,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import { meetingDTO } from "../../types/meeting";
import utilsCommon from "../../shared/utils/common";
import zoomTimezone from "../../pages/Workgroup/WorkgroupMeeting/zoomTimezone";
import i18n from "fds/src/locales/i18n";
import { nanoid } from "@reduxjs/toolkit";
import { t } from "i18next";
const copy = require("clipboard-copy");

interface ShareMeetingLinkModalProps {
  open: boolean;
  onClose: () => void;
  meetingInfo?: meetingDTO;
}
const ShareMeetingLinkModal: React.FC<ShareMeetingLinkModalProps> = ({
  open,
  onClose,
  meetingInfo,
}) => {
  const toasts = useToast();

  let myName = window.localStorage.getItem("fasoo-eco-user")?.split('"')[13];
  let timeInLocale = zoomTimezone.filter(
    (item) => item.id === meetingInfo?.timezone
  )[0];
  const handleCopyLink = () => {
    copy(meetingInfo?.joinUrl);
    toasts.toastMsg(nanoid(), t("meeting.alert.copySuccess"), "success");
  };
  return (
    <Modal
      title={t("meeting.inviteLink")}
      open={open}
      onClose={onClose}
      width={540}
      isFooter={false}
      classes="shareMeetingLink"
      body={
        <Box width="100%" direction="column">
          <Box classes="shareMeetingLink-body">
            <Typography type="body2_rg">
              {t("meeting.linkTitle", { name: myName })}
            </Typography>
            <Typography type="body2_rg" classes="mg mt-20">
              {t("meeting.topic")}: {meetingInfo?.topic}
            </Typography>
            <Typography type="body2_rg">
              {t("meeting.startTime")}:{" "}
              {utilsCommon.renderDateFormat(
                meetingInfo?.startTime,
                i18n.language.includes("ko")
                  ? "YYYY년 MM월 DD일 A hh:mm"
                  : undefined
              )}
              {i18n.language.includes("ko")
                ? timeInLocale?.ko
                : timeInLocale?.en}
            </Typography>
            <Typography type="body2_rg" classes="mg mt-20">
              {t("meeting.joinZoom")}: {meetingInfo?.joinUrl}
            </Typography>
            <Typography type="body2_rg" classes="mg mt-20">
              {t("meeting.meetingId")}: {meetingInfo?.meetingId}
            </Typography>
            <Typography type="body2_rg">
              {t("meeting.password")}: {meetingInfo?.password}
            </Typography>
          </Box>
          <Box classes="shareLinkModal-link">
            <Tooltip
              message={meetingInfo?.joinUrl}
              maxWidth={"calc(100% - 100px)"}
            >
              <Typography
                ellipsis
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_BRAND")}
              >
                {meetingInfo?.joinUrl}
              </Typography>
            </Tooltip>
            <Button
              btnStyle="link"
              label={t("file.action.copyLink")}
              classes="mg ml-auto"
              whiteSpace="pre"
              textColor={getColor("COLOR_TEXT_BRAND")}
              onClick={handleCopyLink}
              leadingIcon={
                <Icons
                  variant="line"
                  label="link"
                  stroke={getColor("COLOR_TEXT_BRAND")}
                />
              }
            />
          </Box>
          <Box height={32} />
        </Box>
      }
    />
  );
};
export default ShareMeetingLinkModal;
